
import React from 'react';
import Immutable from 'immutable';
import cn from 'classnames';
import _ from 'lodash';
import { Row, Checkbox } from 'antd';


import { Link } from 'react-router-dom';
import { alert, promptModal, promptConfirm } from '../../../../../../common/Modal';
import Icon from '../../../../../../common/UI/Icon';

import { checkAccessOnObject } from '../../../../../../../utils/rights';
import PRIVILEGE_CODES from '../../../../../../../configs/privilegeCodes';
import RESOURCE_TYPES from '../../../../../../../configs/resourceTypes';

import getLink from '../../../../../../common/router/getLink';
import routes from '../../../../../../../routes';

import apiActions from '../../../../../../../actions/apiActions';
import modalsActions from '../../../../../../../actions/modalsActions';
import sceneActions from '../../../../../../../actions/sceneActions';
import catalogActions from '../../../../../../../actions/catalogActions';
import userSettingsActions from '../../../../../../../actions/userSettingsActions';
import { validateApiKey } from '../../../../../../../utils/validateApiKey';

import styles from './actions.less';

export function catalogItems(inGroup) {
    const { location, catalog, favoriteCatalogs, t } = this.props;
    const catalogId = catalog?.get('id');

    const isAccess = checkAccessOnObject(RESOURCE_TYPES.CATALOG, catalog, PRIVILEGE_CODES.ACCESS);
    const isAdmin = checkAccessOnObject(RESOURCE_TYPES.CATALOG, catalog, PRIVILEGE_CODES.ADMIN);

    let menu = [];

    // edit catalog
    if (isAdmin) {
        menu.push({
            key: 'catalogEdit',
            label: (
                <Link to={getLink(location, routes.catalogEdit, { catalogId })}>
                    <Icon type="icon setting-10" className={styles.settingIcon} />
                    {t('buttons.configureCatalog')}
                </Link>
            ),
        });
    }


    // access
    if (isAccess) {
        menu.push({
            key: 'catalogAccess',
            label: (
                <a onClick={this.catalogAccess}>
                    <Icon type="icon edition-55" className={cn(styles.settingIcon, styles.settingIconAccess)} />
                    {t('buttons.accessCatalog')}
                </a>
            ),
        });
    }


    // favorite
    if (true) {
        const isFavorite = favoriteCatalogs && favoriteCatalogs.indexOf(catalog.get('id')) > -1;
        const favoriteTitle = isFavorite ? t('buttons.removeFavorite') : t('buttons.addFavorite');
        const favoriteClassName = isFavorite ? styles.settingRemoveFavorite : styles.settingAddFavorite

        menu.push({
            key: 'catalogSetFavorite',
            label: (
                <a onClick={this.catalogSetFavorite} className={favoriteClassName}>
                    <Icon type="icon vote-38" className={cn(styles.settingIcon, styles.settingFavoriteIcon)} />
                    {favoriteTitle}
                </a>
            ),
        });
    }

    // hidden fields
    const hasHiddenFields = catalog.get("fields").find(f => f.get("hidden"));
    const showHiddenFields = !!catalog.get("showHiddenFields");
    if (isAdmin && hasHiddenFields) {
        menu.push({
            key: 'catalogSetShowHiddenFields',
            label: (
                <a onClick={this.catalogSetShowHiddenFields}>
                    <Icon type="icon edition-29" className={styles.settingIcon} />
                    {showHiddenFields ? t('buttons.hideHiddenFields') : t('buttons.showHiddenFields')}
                </a>
            )
        });
    }


    // edit id
    if (isAdmin && !_.startsWith(catalogId, '$')) {
        menu.push({
            key: 'catalogSetId',
            label: (
                <a onClick={this.catalogSetId}>
                    <Icon type="icon edition-59" className={styles.settingIcon} />
                    {t('buttons.setApiKey')}
                </a>
            ),
        });
    }

    // truncate records
    if (isAdmin) {
        menu.push({
            key: 'catalogTruncate',
            label: (
                <a onClick={this.catalogTruncate} className={styles.settingRemove}>
                    <Icon type="icon text-24" className={styles.settingIcon} />
                    {t('buttons.truncateCatalog')}
                </a>
            ),
        });
    }

    // delete catalog
    if (isAdmin) {
        menu.push({
            key: 'catalogRemove',
            label: (
                <a onClick={this.catalogRemove} className={styles.settingRemove}>
                    <Icon type="icon edition-41" className={styles.settingIcon} />
                    {t('buttons.removeCatalog')}
                </a>
            ),
        });
    }

    if (inGroup && menu.length) {
        menu = [
            {
                key: '1',
                type: 'group',
                label: `${t('common.catalog')  } «${  catalog.get('name')  }»`,
                children: menu,
            },
        ]
    }

    return menu;
}

/* Избранный каталог */
export function catalogSetFavorite(e) {
    const { catalog } = this.props;
    const catalogId = catalog?.get('id');

    let { favoriteCatalogs } = this.props;
    if (_.isUndefined(favoriteCatalogs)) {
        favoriteCatalogs = Immutable.List();
    }

    const index = favoriteCatalogs ? favoriteCatalogs.indexOf(catalogId) : -1;

    /**
     * Depends on item existance in the favorite array
     * delete or push item using index
     */
    favoriteCatalogs = index !== -1 ? favoriteCatalogs.splice(index, 1) : favoriteCatalogs.push(catalogId);

    favoriteCatalogs = favoriteCatalogs.filter((i) => !!i);
    userSettingsActions.setKey(['ui', 'favoriteCatalogs'], favoriteCatalogs);
};

/* Задание ID каталогу */
export function catalogSetId() {
    const { t, catalogId, loadingForModal } = this.props;
    promptModal({
        headerText: t('modals.apiKeys.catalogApiKeyConfirm.headerText'),
        defaultValue: catalogId,
        onOk: this.catalogSetIdCallback,
        okText: t('buttons.save'),
        cancelText: t('buttons.cancel'),
        promptHint: t('modals.apiKeys.promptHint'),
        loading: loadingForModal || false,
        validateFunc: validateApiKey,
        t,
    });
};

export async function catalogSetIdCallback(newKey) {
    const { catalogId, catalog, location, history, sceneId, t } = this.props;
    const sectionId = catalog?.get('sectionId');

    if (catalogId && sectionId) {
        try {
            // Не задано? Явно указываем null
            // => удаляем запись из recordIds и получаем числовой dbId как раньше
            newKey = _.isEmpty(_.trim(newKey)) ? null : newKey;
            await apiActions.updateCatalog({ catalogId, sectionId }, { id: newKey }, { sceneId }).then((result) => {
                const realNewId = result.id || newKey;
                history.push({
                    pathname: `/section/${sectionId}/catalog/${realNewId}`,
                    search: _.get(location, ['search'], ''),
                });
            });
            catalogActions.truncateCatalogFromStore({ catalogId });
        } catch (e) {
            alert({
                headerText: t('message.saveError'),
                text: t('modals.setApiKeyErrors.onSaveError'),
                okText: t('modals.setApiKeyErrors.okText'),
            });
        }
    }
};

/* Форма доступа */
export function catalogAccess(e) {
    const { catalog } = this.props;
    const sectionId = catalog?.get('sectionId');
    const catalogId = catalog?.get('id');

    if (catalogId) {
        const isAdmin = checkAccessOnObject(RESOURCE_TYPES.CATALOG, catalog, PRIVILEGE_CODES.ADMIN);
        const readOnly = !checkAccessOnObject(RESOURCE_TYPES.CATALOG, catalog, PRIVILEGE_CODES.ACCESS);
        const object = { catalogId };
        const parents = [{ sectionId }];
        modalsActions.openAccessModal({ object, parents }, RESOURCE_TYPES.CATALOG, { readOnly, isAdmin });
    }
};

/* Показать/скрыть скрытые поля */
export function catalogSetShowHiddenFields(e) {
    const { catalog } = this.props;
    const catalogId = catalog.get("id");
    const value = catalog.get("showHiddenFields");

    catalogActions.catalogShowHiddenFields(catalogId, !value);
};

/* Удаление всех записей */
export function catalogTruncate() {
    const { catalog, sceneId, match, t } = this.props;
    const catalogId = catalog?.get('id');

    const viewId = match && match.params.viewId;

    promptConfirm({
        headerText: t('modals.truncateConfirm.headerText'),
        text: (
            <span>
                {t('modals.truncateConfirm.firstText')}
                <br />
                {t('modals.truncateConfirm.secondText')}
            </span>
        ),
        okText: t('modals.truncateConfirm.okText'),
        cancelText: t('modals.truncateConfirm.cancelText'),
        value: catalog.get('name'),
        placeHolder: catalog.get('name'),
        onOk: () => {
            apiActions
                .deleteRecord(
                    {
                        catalogId,
                        recordId: '$all',
                    },
                    { sceneId, viewId },
                )
                .then(() => {
                    /* в случае удачного удаления, происходит перезапись текущих записей новыми (т.е. пустым объектом) можно просто удалить все записи из сцены */
                    /*
                    recordActions.requestForRecords(catalogId, sceneId, {
                      viewId: this.props.match && this.props.match.params.viewId
                    });
                  */
                    sceneActions.deleteRecordsFromScene(sceneId);
                });
        },
    });
};

/* Удаление каталога */
export function catalogRemove() {
    if (this.isSchemaLocked()) {
        return;
    }

    const { catalog, history, location, sceneId, t } = this.props;
    const sectionId = catalog?.get('sectionId');
    const catalogId = catalog?.get('id');

    promptConfirm({
        headerText: t('modals.removeConfirm.headerText'),
        text: (
            <span>
                {t('modals.removeConfirm.firstText')}
                <br />
                {t('modals.removeConfirm.secondText')}
            </span>
        ),
        okText: t('modals.removeConfirm.okText'),
        cancelText: t('modals.removeConfirm.cancelText'),
        value: catalog.get('name'),
        placeHolder: catalog.get('name'),
        onOk: () => {
            apiActions
                .deleteCatalog(
                    {
                        catalogId,
                    },
                    { sceneId },
                )
                .then(() => {
                    history.push({
                        pathname: `/section/${sectionId}`,
                        search: location.search,
                    });
                });
            /* Удаление каталога вызывает удаление сцены */
            sceneActions.deleteScene(sceneId);
        },
    });
};
export function isSchemaLocked() {
    const { t } = this.props;
    const isSchemaLocked = this.props.license && this.props.license.getIn(['modules', 'schemalock']);
    if (isSchemaLocked) {
        alert({
            headerText: t('modals.schemaLock.headerText'),
            text: t('modals.schemaLock.text'),
            okText: t('modals.schemaLock.okText'),
        });
    }
    return isSchemaLocked;
};

